export default __webpack_public_path__ + "pypi/streamlit-1.32.2-cp311-none-any.whl";